import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const ButtonSlidePanelForm = ({
  isOpen,
  onClose,
  onSave,
  buttonColor,
  userId,
  buttonId,
}) => {
  const [numColumns, setNumColumns] = useState(1);
  const [columnSpacing, setColumnSpacing] = useState(10);
  const [buttonText, setButtonText] = useState("");
  const [enableOffset, setEnableOffset] = useState(false);
  const [leftOffset, setLeftOffset] = useState(5);
  const [topOffset, setTopOffset] = useState(5);
  const [rightOffset, setRightOffset] = useState(0);

  const [enableVideoEndOffset, setEnableVideoEndOffset] = useState(false);
  const [videoEndLeftOffset, setVideoEndLeftOffset] = useState(0);
  const [videoEndRightOffset, setVideoEndRightOffset] = useState(0);
  const [videoEndTopOffset, setVideoEndTopOffset] = useState(5);

  /////Disable Button Animation///////////////
  const [disableAnimation, setDisableAnimation] = useState(false);

  /////Enable Next Navigation///////////////
  const [enableNextNavigation, setEnableNextNavigation] = useState(false);
  const [nextButtonTopOffset, setNextButtonTopOffset] = useState(null);
  const [nextButtonLeftOffset, setNextButtonLeftOffset] = useState(null);
  const [nextButtonRightOffset, setNextButtonRightOffset] = useState(null);
  const [nextButtonBottomOffset, setNextButtonBottomOffset] = useState(null);

  /////Enable Video End Navigation///////////////
  const [enableVideoEndNavigation, setEnableVideoEndNavigation] = useState(false);
  const [videoEndNavigationMenuId, setVideoEndNavigationMenuId] = useState(null);
  const [availableMenus, setAvailableMenus] = useState([]);
  const [currentLanguage] = useState('en'); // Default language for fetching menus

  /////Wheelchair Content Offset///////////////
  const [wheelchairContentOffsetY, setWheelchairContentOffsetY] = useState(20);

  const handleSave = () => {
    const config = {
      numColumns,
      columnSpacing,
      enableOffset,
      leftOffset,
      topOffset,
      buttonId,
      rightOffset,

      ///////////////////
      disableAnimation,
      enableVideoEndOffset,
      videoEndTopOffset,
      videoEndLeftOffset,
      videoEndRightOffset,
      enableNextNavigation,
      nextButtonTopOffset,
      nextButtonLeftOffset,
      nextButtonRightOffset,
      nextButtonBottomOffset,
      wheelchairContentOffsetY,
      // Video End Navigation
      enableVideoEndNavigation,
      videoEndNavigationMenuId,
    };
    onSave(config); // Pass the configuration to the parent component
    onClose(); // Close the side panel
  };

  useEffect(() => {
    axios
      .get(`/api/frontendbutton-main-settings/${buttonId}/${userId}/en`)
      .then((response) => {
        if (response.data.error) {
        } else {
          console.log("Fetched Button Main Menu Settings:", response.data);
          setNumColumns(response.data?.finalSettings?.numColumns);
          setColumnSpacing(response.data?.finalSettings?.columnSpacing);
          setButtonText(response.data?.buttonText);
          setEnableOffset(response.data?.finalSettings?.enableOffset);
          setColumnSpacing(response.data?.finalSettings?.columnSpacing);
          setLeftOffset(response.data?.finalSettings?.leftOffset);
          setTopOffset(response.data?.finalSettings?.topOffset);
          setRightOffset(response.data?.finalSettings?.rightOffset);

          // Newly Added
          setDisableAnimation(response.data?.finalSettings?.disableAnimation);

          setEnableVideoEndOffset(
            response.data?.finalSettings?.enableVideoEndOffset ?? false,
          );

          setVideoEndLeftOffset(
            response.data?.finalSettings?.videoEndLeftOffset,
          );
          setVideoEndRightOffset(
            response.data?.finalSettings?.videoEndRightOffset,
          );
          setVideoEndTopOffset(response.data?.finalSettings?.videoEndTopOffset);

          setEnableNextNavigation(
            response.data?.finalSettings?.enableNextNavigation ?? false,
          );
          setNextButtonTopOffset(
            response.data?.finalSettings?.nextButtonTopOffset ?? null,
          );
          setNextButtonLeftOffset(
            response.data?.finalSettings?.nextButtonLeftOffset ?? null,
          );
          setNextButtonRightOffset(
            response.data?.finalSettings?.nextButtonRightOffset ?? null,
          );
          setNextButtonBottomOffset(
            response.data?.finalSettings?.nextButtonBottomOffset ?? null,
          );

          setWheelchairContentOffsetY(
            response.data?.finalSettings?.wheelchairContentOffsetY ?? 20,
          );

          // Video End Navigation
          setEnableVideoEndNavigation(
            response.data?.finalSettings?.enableVideoEndNavigation ?? false,
          );
          setVideoEndNavigationMenuId(
            response.data?.finalSettings?.videoEndNavigationMenuId ?? null,
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching menus:", error);
      });

    // Fetch available menus for dropdown (both primary menus and frontend main menus)
    axios
      .get(`/api/primarymenus/${userId}/${currentLanguage}`)
      .then((response) => {
        if (response.data.error) {
          console.log('No Menus Found');
        } else {
          console.log("Primary menus response:", response.data);

          const allMenus = [];

          // Extract primary menus (from menus array)
          if (response.data?.data?.menus) {
            response.data.data.menus.forEach((menu) => {
              allMenus.push({
                id: menu._id,
                name: menu.name,
                type: 'primary'
              });
            });
          }

          // Extract frontend main menus
          // if (response.data?.data?.frontendmainmenu) {
          //   response.data.data.frontendmainmenu.forEach((menu) => {
          //     allMenus.push({
          //       id: menu._id,
          //       name: menu.name,
          //       type: 'frontend'
          //     });
          //   });
          // }

          // Add "Main Menu" option at the end
          allMenus.push({
            id: 'main_menu',
            name: 'Main Menu',
            type: 'main'
          });

          setAvailableMenus(allMenus);
          console.log("Available menus for dropdown:", allMenus);
        }
      })
      .catch((error) => {
        console.error('Error fetching menus:', error);
      });
  }, [buttonId, userId, currentLanguage]);

  return (
    <div className={`side-panel ${isOpen ? "open" : ""}`}>
      <div className="side-panel-content">
        <h4 style={{ textAlign: "center" }}>{buttonText}</h4>

        {/* Number of Columns */}
        <div className="row" style={{ marginTop: "31px" }}>
          <div className="col-md-12">
            <span>Number of Button Columns:</span>
            <div className="setting form-group">
              <select
                value={numColumns}
                onChange={(e) => setNumColumns(e.target.value)}
                className="form-control"
              >
                <option value={""}>Select Button Columns</option>
                <option value={"center-single-row"}>Center Single Row</option>
                <option value={"center-two-buttons-per-row"}>
                  Center 2 Buttons Per Row
                </option>
                <option value={"left-side-one-button-per-row"}>
                  Left Side One Button Per Row
                </option>
                <option value={"right-side-one-button-per-row"}>
                  Right Side One Button Per Row
                </option>
                <option value={"unlimited-buttons-center"}>
                  Unlimited Buttons Center (Animation from each side)
                </option>
                <option value={"unlimited-left-buttons-center"}>
                  Unlimited Left Buttons Center (Animation from left side)
                </option>
                <option value={"unlimited-right-buttons-center"}>
                  Unlimited Right Buttons Center (Animation from right side)
                </option>
              </select>
            </div>
          </div>
        </div>

        {/* Button Alignment */}

        {/* <div className="row">
        
          <div className="col-md-12">
          <span>Choose Buttons Alignment</span>
        
        <div  style={{
            marginTop:"10px",
            display: 'inline-flex',
            gap: '26px'
          }} >
        <div className="setting form-group custom-control custom-radio">    
          
            
              <input
              
                type="radio"
                value="left"
                id={`left-${buttonId}`}
                className="custom-control-input"
                checked={buttonAlignment === "left"}
                onChange={() => setButtonAlignment("left")}
              />
              <label className="custom-control-label" htmlFor={`left-${buttonId}`}>Left </label>
        </div>
        <div className="setting form-group custom-control custom-radio">
           
              <input
                type="radio"
                value="center"
                className="custom-control-input"
                checked={buttonAlignment === "center"}
                onChange={() => setButtonAlignment("center")}
                id={`center-${buttonId}`}
              />
              
            <label className="custom-control-label" htmlFor={`center-${buttonId}`}>Center</label>

        </div>

        <div className="setting form-group custom-control custom-radio">
            
              <input
                type="radio"
                value="right"
                className="custom-control-input"
                checked={buttonAlignment === "right"}
                onChange={() => setButtonAlignment("right")}
                id={`right-${buttonId}`}
              />
              
            <label className="custom-control-label" htmlFor={`right-${buttonId}`}>Right </label>
          
        </div>

        </div>


        </div>
        </div> */}

        {/* Column Spacing */}
        <div className="setting form-group">
          <label style={{ fontWeight: "normal" }}>
            Button Column Spacing In px:
          </label>
          <input
            type="number"
            className="form-control"
            value={columnSpacing}
            onChange={(e) => setColumnSpacing(Number(e.target.value))}
          />
        </div>

        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={disableAnimation}
            onChange={(e) => setDisableAnimation(e.target.checked)}
            id={`disable_animation_${buttonId}`}
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor={`disable_animation_${buttonId}`}
          >
            Disable Button Animation{" "}
          </label>
        </div>

        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableOffset}
            onChange={(e) => setEnableOffset(e.target.checked)}
            id={`enable_offset_${buttonId}`}
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor={`enable_offset_${buttonId}`}
          >
            Enable Offset{" "}
          </label>
        </div>

        {enableOffset && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Enter Left Offset in %:
              </label>
              <input
                type="number"
                className="form-control"
                value={leftOffset}
                onChange={(e) => setLeftOffset(Number(e.target.value))}
              />
            </div>
            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Enter Right Offset in %:
              </label>
              <input
                type="number"
                className="form-control"
                value={rightOffset}
                onChange={(e) => setRightOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Enter Top Offset in %:
              </label>
              <input
                type="number"
                className="form-control"
                value={topOffset}
                onChange={(e) => setTopOffset(Number(e.target.value))}
              />
            </div>
          </div>
        )}

        {/* Enable Secondary Menu */}
        {/* <div className="setting">
          <label>
            <input
              type="checkbox"
              checked={enableSecondaryMenu}
              onChange={(e) => setEnableSecondaryMenu(e.target.checked)}
            />
            Enable Secondary Menu
          </label>
        </div> */}

        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableVideoEndOffset}
            onChange={(e) => setEnableVideoEndOffset(e.target.checked)}
            id={`enable_video_offset_${buttonId}`}
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor={`enable_video_offset_${buttonId}`}
          >
            Enable Video End Offset{" "}
          </label>
        </div>

        {enableVideoEndOffset && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Video End Left Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={videoEndLeftOffset}
                onChange={(e) => setVideoEndLeftOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Video End Right Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={videoEndRightOffset}
                onChange={(e) => setVideoEndRightOffset(Number(e.target.value))}
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Video End Top Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={videoEndTopOffset}
                onChange={(e) => setVideoEndTopOffset(Number(e.target.value))}
              />
            </div>
          </div>
        )}

        {/* Enable Next Navigation */}
        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableNextNavigation}
            onChange={(e) => setEnableNextNavigation(e.target.checked)}
            id={`enable_next_navigation_${buttonId}`}
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor={`enable_next_navigation_${buttonId}`}
          >
            Enable Next Navigation
          </label>
        </div>

        {/* Wheelchair Content Offset */}
        <div className="setting form-group">
          <label style={{ fontWeight: "normal" }}>
            Wheelchair Mode Content Offset (%):
          </label>
          <input
            type="number"
            className="form-control"
            value={wheelchairContentOffsetY}
            onChange={(e) => setWheelchairContentOffsetY(Number(e.target.value))}
            min="0"
            max="50"
          />
          <small style={{ color: '#666', display: 'block', marginTop: '4px' }}>
            Content will move down by this percentage when wheelchair mode is active
          </small>
        </div>

        {/* Enable Video End Navigation to Menu */}
        <div className="setting form-group custom-control custom-checkbox">
          <input
            type="checkbox"
            checked={enableVideoEndNavigation}
            onChange={(e) => setEnableVideoEndNavigation(e.target.checked)}
            id={`enable_video_end_navigation_${buttonId}`}
            className="custom-control-input"
          />

          <label
            className="custom-control-label"
            htmlFor={`enable_video_end_navigation_${buttonId}`}
          >
            Enable Video End Navigation to Menu
          </label>
        </div>

        {enableVideoEndNavigation && (
          <div className="setting form-group">
            <label style={{ fontWeight: "normal" }}>
              Select Menu to Navigate:
            </label>
            <select
              value={videoEndNavigationMenuId || ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                console.log("Selected menu ID:", selectedId);
                setVideoEndNavigationMenuId(selectedId);
              }}
              className="form-control"
            >
              <option value="">Select a menu...</option>
              {availableMenus.map((menu) => (
                <option key={menu.id} value={menu.id}>
                  {menu.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Next Button Offset Fields */}
        {/* {enableNextNavigation && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
               Top Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={nextButtonTopOffset ?? ""}
                onChange={(e) =>
                  setNextButtonTopOffset(
                    e.target.value === "" ? null : Number(e.target.value),
                  )
                }
                placeholder="Leave empty to unset"
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Left Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={nextButtonLeftOffset ?? ""}
                onChange={(e) =>
                  setNextButtonLeftOffset(
                    e.target.value === "" ? null : Number(e.target.value),
                  )
                }
                placeholder="Leave empty to unset"
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
               Right Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={nextButtonRightOffset ?? ""}
                onChange={(e) =>
                  setNextButtonRightOffset(
                    e.target.value === "" ? null : Number(e.target.value),
                  )
                }
                placeholder="Leave empty to unset"
              />
            </div>

            <div className="setting form-group">
              <label style={{ fontWeight: "normal" }}>
                Bottom Offset %:
              </label>
              <input
                type="number"
                className="form-control"
                value={nextButtonBottomOffset ?? ""}
                onChange={(e) =>
                  setNextButtonBottomOffset(
                    e.target.value === "" ? null : Number(e.target.value),
                  )
                }
                placeholder="Leave empty to unset"
              />
            </div>
          </div>
        )} */}

        {/* Save and Cancel Buttons */}
        <div className="actions">
          <button
            type="button"
            onClick={handleSave}
            style={{ backgroundColor: buttonColor?.buttonColor }}
          >
            Save
          </button>
          {/* <button type="button" onClick={onClose} style={{backgroundColor:buttonColor?.buttonColor}}>Cancel</button> */}
          <button
            type="button"
            style={{
              backgroundColor: buttonColor?.buttonColor,
              color: "#ffff",
            }}
          >
            <Link
              style={{ color: "#fff" }}
              to={`/view-global-settings/${buttonId}/${userId}`}
            >{`Add Content`}</Link>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ButtonSlidePanelForm;
